/**
 * Configuração global do produto Cardápio Digital.
 * Domínio fictício — troque quando tiver o domínio real.
 */
export const CARDAPIO_DOMINIO_BASE = 'https://cardapio.exemplo.com.br';

/** Mesas padrão ao cadastrar um restaurante novo. */
export const CARDAPIO_MESAS_PADRAO = 20;

/** Dias de tolerância após o vencimento antes de suspender. */
export const CARDAPIO_DIAS_TOLERANCIA = 3;

export type ModoCozinha = 'junto' | 'separado';

export type PlanoCardapio = 'basico' | 'pro';

export const PLANOS_CARDAPIO: Record<
  PlanoCardapio,
  { label: string; maxMesas: number; modoCozinha: ModoCozinha; precoMensal: number }
> = {
  basico: { label: 'Básico', maxMesas: 20, modoCozinha: 'junto', precoMensal: 97 },
  pro: { label: 'Pro', maxMesas: 50, modoCozinha: 'separado', precoMensal: 147 },
};

/** Monta URL pública do cardápio (cliente na mesa). */
export function urlCardapioCliente(slug: string, mesa: number): string {
  const u = new URL(CARDAPIO_DOMINIO_BASE);
  u.searchParams.set('modo', 'cardapio');
  u.searchParams.set('r', slug);
  u.searchParams.set('mesa', String(mesa));
  return u.toString();
}

/** URL do painel do balcão (dono / balconista). */
export function urlCardapioPainel(slug: string): string {
  const u = new URL(CARDAPIO_DOMINIO_BASE);
  u.searchParams.set('modo', 'cardapio-painel');
  u.searchParams.set('r', slug);
  return u.toString();
}

/** URL da cozinha (quando modo separado). */
export function urlCardapioCozinha(slug: string): string {
  const u = new URL(CARDAPIO_DOMINIO_BASE);
  u.searchParams.set('modo', 'cardapio-cozinha');
  u.searchParams.set('r', slug);
  return u.toString();
}

/** URL para teste no mesmo navegador/PC (usa origem atual em vez do domínio fictício). */
export function urlCardapioClienteLocal(slug: string, mesa: number): string {
  if (typeof window === 'undefined') return urlCardapioCliente(slug, mesa);
  const u = new URL(window.location.href);
  u.search = '';
  u.searchParams.set('modo', 'cardapio');
  u.searchParams.set('r', slug);
  u.searchParams.set('mesa', String(mesa));
  return u.toString();
}

export function urlCardapioPainelLocal(slug: string): string {
  if (typeof window === 'undefined') return urlCardapioPainel(slug);
  const u = new URL(window.location.href);
  u.search = '';
  u.searchParams.set('modo', 'cardapio-painel');
  u.searchParams.set('r', slug);
  return u.toString();
}

export function urlCardapioCozinhaLocal(slug: string): string {
  if (typeof window === 'undefined') return urlCardapioCozinha(slug);
  const u = new URL(window.location.href);
  u.search = '';
  u.searchParams.set('modo', 'cardapio-cozinha');
  u.searchParams.set('r', slug);
  return u.toString();
}

/** Slug seguro a partir do nome do restaurante. */
export function slugificarNome(nome: string): string {
  return nome
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 48);
}
